module.exports = __webpack_public_path__ + "img/header-diamondJewelryPresentsWomen@2x.5d6a48e.jpg";